import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { Field } from 'formik';
import { Select } from '@material-ui/core';

interface Props {
  quantity: number,
  name: string,
  onChange: (quantity: number) => void,
}

export default ((props) => {
  return (
    <Field style={{ fontSize: 16, }} required fullWidth name={props.name} label='Quantity' id={props.name} value={props.quantity} onChange={(event: React.ChangeEvent<HTMLSelectElement>) => props.onChange(Number(event.target.value))} component={Select} >
      <MenuItem key={0} value={0}>0</MenuItem>
      <MenuItem key={1} value={1}>1</MenuItem>
    </Field >
  );
}) as React.FC<Props>;